<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        append-icon="event"
        solo
        hide-details
        readonly
        v-on="on"
        v-on:click:append="menu=true"
      ></v-text-field>
    </template>
    <v-date-picker :show-week="true" :first-day-of-week="1" :locale-first-day-of-year="4" v-model="date" no-title scrollable @input="$refs.menu.save(date)"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ['label', 'value'],
  data () {
    return {
      menu: false,
      date: ''
    }
  },
  watch: {
    date: {
      handler (val) {
        this.$emit('input', val)
      }
    },
    value: {
      handler (val) {
        this.date = val
      },
      immediate: true
    }
  }
}
</script>
